import type { Component, InjectionKey } from 'vue';

/**
 * createAxApp 옵션으로 주입. AdminLayout 위에 Tier 전용 오버레이(예: MES Agent 패널)를 렌더한다.
 */
export const ADMIN_LAYOUT_OVERLAY_KEY: InjectionKey<Component | null> =
  Symbol('adminLayoutOverlay');
